import { SortingMethod, getSortingMethod } from '../../utils';
import { ChartSize, LinearData, LinearDatum, Statistics, TwoCategoryData, TwoCategoryDatum } from '../../types';
import { BarChartDimensions } from './types';

export const sizeToDimension = (size: ChartSize | BarChartDimensions): BarChartDimensions => {
  if (typeof size !== 'string') {
    return size;
  }

  switch (size) {
    case ChartSize.small:
      return { width: 300, height: 200, fontSize: 30 };
    case ChartSize.large:
      return { width: 500, height: 400, fontSize: 38 };
    case ChartSize.medium:
    default:
      return { width: 400, height: 300, fontSize: 34 };
  }
};

export const statsBy: (arr: LinearData | TwoCategoryData, sortingMethod: SortingMethod) => Statistics = (
  arr,
  sortingMethod
) => {
  const isKeyArray = Array.isArray(arr[0].key);

  const counts = (arr as (LinearDatum | TwoCategoryDatum)[]).reduce((prev, curr) => {
    if (!curr.value) {
      return prev;
    }
    const currentKey = isKeyArray ? ((curr as TwoCategoryDatum).key[1] as string) : 'default';
    if (!prev[currentKey as string]) {
      prev[currentKey as string] = {
        value: curr.value,
        min: curr.value,
        max: curr.value,
        values: [curr.value],
      };
    } else {
      prev[currentKey as string] = {
        value: prev[currentKey as string].value + curr.value,
        min: Math.min(prev[currentKey as string].min, curr.value),
        max: Math.max(prev[currentKey as string].max, curr.value),
        values: [...prev[currentKey as string].values, curr.value],
      };
    }
    return prev;
  }, {} as Record<string, { value: number; min: number; max: number; values: number[] }>);

  return Object.keys(counts)
    .map((key) => ({
      key: key,
      value: counts[key].value,
      min: counts[key].min,
      max: counts[key].max,
      values: counts[key].values,
      first: counts[key].values[0],
      last: counts[key].values[counts[key].values.length - 1],
      trending: {
        overall:
          ((counts[key].values[counts[key].values.length - 1] - counts[key].values[0]) * 100) / counts[key].values[0],
      },
    }))
    .sort(getSortingMethod(sortingMethod));
};
